import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface Template {
    id: string;
    title: string;
    icon: string;
    tag: string;
}

interface TemplatesState {
    templates: Template[];
    currentTemplate: Template | null;
    loading: boolean;

}
const initialState: TemplatesState = {
    templates: [],
    currentTemplate: null,
    loading: false,
};

const templatesSlice = createSlice({
    name: 'templates',
    initialState,
    reducers: {
        setCurrentTemplate(state, action: PayloadAction<Template>) {
            state.currentTemplate = action.payload;
        },

    },

});

export const { setCurrentTemplate } = templatesSlice.actions;

export default templatesSlice.reducer;
